import { Get as Get$1 } from './individual-credit-report.dto.mjs';

var Get;
(function (Get) {
    Get.responseSchema = Get$1.responseSchema;
})(Get || (Get = {}));

export { Get };
